import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-assistist-integration-preview',
  templateUrl: './integration-preview.component.html',
  styleUrls: ['./integration-preview.component.scss'],
})
export class AssististIntegrationPreviewComponent implements OnInit {
  integration: any;
  viewMode: 'mobile' | 'desktop' = 'mobile';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.integration = this.activatedRoute.snapshot.data.integration;
  }

  get providerName(): string {
    return this.integration?.provider?.name || 'Integration';
  }

  get docsUrl(): any[] {
    return ["/docs", "integration", this.integration?.id];
  }

  goBack(): void {
    this.router.navigate(['..'], { relativeTo: this.activatedRoute });
  }
}
